import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { styled } from "@mui/material/styles";

const Root = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  "&& .MuiPaper-root.MuiCard-root": {
    position: "relative",
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    backgroundColor: theme.palette.background.body,
    border: "1px solid",
    borderColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.30)"
        : "rgba(0, 0, 0, 0.12)",
  },
}));
export default function ContentDescription({ children }) {
  const textRef = useRef();
  const description = children;
  const [expandable, setExpandable] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const expandable =
      textRef.current.scrollHeight > textRef.current.clientHeight;
    setExpandable(expandable);
  }, [children]);

  const onClickButton = useCallback(() => setExpanded((v) => !v), []);

  return (
    <Root>
      <Card elevation={0}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          dangerouslySetInnerHTML={{ __html: description }}
          ref={textRef}
          sx={{
            overflow: "hidden",
            maxHeight: {
              xs: expanded ? "auto" : "calc(0.8rem * 3)",
              sm: expanded ? "auto" : "calc(1.1rem * 3)",
            },
            fontSize: {
              xs: "0.8rem",
              sm: "1.1rem",
            },
            "& a": {
              color: "#81d4fa",
            },
            "& p": {
              "&:first-of-type": {
                marginTop: 0,
              },
              "&:last-child": {
                marginBottom: 0,
              },
            },
          }}
        />

        {expandable && (
          <IconButton
            onClick={onClickButton}
            sx={{
              position: "absolute",
              top: 6,
              right: 6,
            }}
          >
            {!expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowLeftIcon />}
          </IconButton>
        )}
      </Card>
    </Root>
  );
}

ContentDescription.propTypes = {
  children: PropTypes.string,
};
